export default {
  projectName: {
    'zh-cn': '蜂巢智能管控平台',
    'zh-tw': '蜂巢智能管控平台',
    'en': 'Honeycomb Smart'
  },
  dashboard: {
    'zh-cn': '蜂巢看板',
    'zh-tw': '蜂巢看板',
    'en': 'Honeycomb Dashboard'
  },
  language: {
    'zh-cn': '语言',
    'zh-tw': '語言',
    'en': 'Language'
  },
  certification: {
    authenticated: {
      'zh-cn': '已认证',
      'zh-tw': '已認證',
      'en': 'Authenticated'
    },
    companyName: {
      'zh-cn': '企业名称：',
      'zh-tw': '企業名稱：',
      'en': 'Company Name:'
    },
    creditCode: {
      'zh-cn': '统一社会信用代码：',
      'zh-tw': '統一社會信用代碼：',
      'en': 'Unified Social Credit Code:'
    },
    unauthenticated: {
      'zh-cn': '未认证企业',
      'zh-tw': '未認證企業',
      'en': 'Unauthenticated Enterprise'
    },
    pleaseCertify: {
      'zh-cn': '请先进行企业认证',
      'zh-tw': '請先進行企業認證',
      'en': 'Please complete enterprise certification first'
    }
  }
}

